import { Stack, Typography } from "@mui/material";
import { FileDropZone } from "../../FileDropZone";
import { FileList } from "../../FileList";
import { FileListItem } from "../../HGInsightsBlock";
import { ReuseButton } from "../../ReuseButton";
import { TrashIcon } from "../../../images";
import { ButtonsColorType, ButtonsType } from "../../../../types/enums";
import { BASE_API_URL } from "../../../../api";

type Props = {
  uploadedFiles: File[];
  isLoading: boolean;
  onFileUpload: (files: File[]) => void;
  removeFileHandler: (fileName: string) => void;
  changeFileHandler: (fileName: string, file: File) => void;
  ignoredAccounts: string[];
  isResetIgnore: boolean;
  setIsResetIgnore: () => void;
};

export const ExcludeAccountsBlock = ({
  uploadedFiles,
  isLoading,
  onFileUpload,
  removeFileHandler,
  changeFileHandler,
  ignoredAccounts,
  isResetIgnore,
  setIsResetIgnore,
}: Props) => {
  return (
    <Stack sx={{ maxWidth: "400px", gap: "20px" }}>
      <Stack
        sx={{
          backgroundColor: "#F7F7F7",
          border: "1px solid #DEDEDE",
          borderRadius: "16px",
          padding: "16px",
          gap: "12px",
        }}
      >
        <Stack gap={"8px"}>
          <Typography variant="subtitle1" fontWeight="500">
            Exclude accounts from Search
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Upload a CSV with accounts to exclude from search results. The
            current campaign target list is already excluded automatically.
          </Typography>
          <br />
          <Typography variant="body1" color="text.secondary">
            Use the{" "}
            <a
              href={`${BASE_API_URL}/examples/input-csv?file_type=ignored`}
              style={{
                color: "#1C3C6C",
                textUnderlineOffset: "3px",
              }}
            >
              current accounts list CSV
            </a>{" "}
            to review existing exclusions and add more accounts
          </Typography>
        </Stack>
        <FileDropZone
          uploadedFiles={uploadedFiles}
          onFileUpload={onFileUpload}
          acceptedExtensions={["csv", "xls", "xlsx"]}
          customTitle={"Upload your file here (CSV or XLSX)"}
        />
        <FileList
          files={uploadedFiles}
          isDisabled={isLoading}
          removeFileHandler={removeFileHandler}
          changeFileHandler={changeFileHandler}
          acceptedExtensions={["csv", "xls", "xlsx"]}
        />
      </Stack>
      {!isResetIgnore && !!ignoredAccounts.length && (
        <Stack paddingLeft={"3px"}>
          <Stack gap={"8px"} paddingLeft={"13px"}>
            <Typography variant={"subtitle1"} sx={{ fontWeight: 500 }}>
              Uploaded Files
            </Typography>
            {ignoredAccounts.map((account) => (
              <FileListItem key={account} fileName={account} />
            ))}
          </Stack>
          <ReuseButton
            onClick={setIsResetIgnore}
            buttonColor={ButtonsColorType.red}
            buttonType={ButtonsType.text}
            startIcon={<TrashIcon color={"#CF3E00"} />}
            style={{ alignSelf: "flex-start" }}
          >
            Remove all files
          </ReuseButton>
        </Stack>
      )}
    </Stack>
  );
};
